import 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { firebaseConfig } from './utils/utils';

const firebaseApp = initializeApp({
  apiKey: firebaseConfig.APIKEY,
  authDomain: firebaseConfig.AUTHDOMAIN,
  projectId: firebaseConfig.PROJECTID,
  storageBucket: firebaseConfig.STORAGEBUCKET,
  messagingSenderId: firebaseConfig.MESSAGINGSENDERID,
  appId: firebaseConfig.APPID,
  measurementId: firebaseConfig.MEASUREMENTID,
});

export const messaging = (() => {
  try {
    return getMessaging(firebaseApp) as any;
  } catch (error) {
    console.error('Firebase messaging initialization error:', error);
    return null;
  }
})();